<template lang="pug">
  .dashboard
    .max-width
      .row.wrapped.gap-2.boards
        .col.board(v-for="board in publicBoards", :key="board._id")
          BoardPreview(:board="board")
</template>

<script>

import { mapState } from 'vuex'

import BoardPreview from '@/components/BoardPreview'

export default {
  name: 'PublicDashboard',
  components: {
    BoardPreview
  },
  data () {
    return {
      count: 0
    }
  },
  beforeMount () {
    //console.log(this.company.isMember)
    //console.log(this.boards.length)
  },
  computed: {
    ...mapState({
      company: state => state.company,
      boards: state => state.boards.list
    }),
    publicBoards () {
      return this.boards.filter(board => board.public)
    }
  },
  methods: {
    checkRedirect () {
      //console.log('checkRedirect')
      if (!this.company.isMember && this.boards.length === 1) {
        let board = this.boards[0]
        this.$router.push({ name: 'PublicBoard', params: { boardSlug: board.slug }})
        //console.log(' we should redirect')
      }
    }
  },
  watch: {
    company () {
      this.count++
      if (this.count == 2) {
        this.checkRedirect()
      }
    },
    boards () {
      this.count++
      if (this.count == 2) {
        this.checkRedirect()
      }
    }
  }
}

</script>

<style lang="stylus" scoped>
  .dashboard
    .boards
      +for_breakpoint(desktop)
        padding-top 3rem
    .board
      width 33.33%
      max-width 33.33%
      min-width 33.33%
      +for_breakpoint(mobile)
        min-width 100%
        max-width 100%
</style>
